import { combineReducers } from 'redux';
import auth from './auth/auth.reducer';
import feed from './feed/feed.reducer';
import profile from './profile/profile.reducer';
import notifications from './notifications/notifications.reducer';
import { LOGOUT_USER } from './auth/auth.actionTypes';

const appReducer = combineReducers({
  auth,
  feed,
  profile,
  notifications,
});

const rootReducer = (state, action) => {
  // clear full state if LOGOUT_USER action was deteceted
  if (action.type === LOGOUT_USER) {
    state = undefined; // NOTE: set only to 'undefined', not to 'null'
  }
  return appReducer(state, action);
};

export default rootReducer;
